import { useNullableDealerAccountInfo } from "./useNullableDealerAccountInfo";

export const useDealerEnableCustomerLogin = (): boolean => {
  const dealer = useNullableDealerAccountInfo();
  return String(dealer?.dealerEnableMembershipPricing) === "1";
};
